module.exports = __webpack_public_path__ + "static/media/loading.a1173d4e.gif";